<h1 class="visually-hidden">{{ 'management.management' | transloco }}</h1>
@if (!loading) {
  <div class="padding">
    <mat-card>
      <mat-card-content>
        <div class="table-container">
          <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex">
            @if (hasUserAccess) {
              <mat-tab [label]="'common.labels.userGroups' | transloco">
                <app-user-groups-list></app-user-groups-list>
              </mat-tab>
              <mat-tab [label]="'management.userSearch' | transloco">
                <app-search-users></app-search-users>
              </mat-tab>
            }
            @if (hasPartyAccess) {
              <mat-tab [label]="'common.labels.parties' | transloco">
                <app-reusable-party-list></app-reusable-party-list>
              </mat-tab>
            }
            @if (hasBrandAccess) {
              <mat-tab [label]="'common.labels.brands' | transloco">
                <div class="padding">
                  <lib-brand-management [corporationID]="corporationID"></lib-brand-management>
                </div>
              </mat-tab>
            }
            @if (hasAlertAccess) {
              <mat-tab label="Alerts">
                <div class="padding">
                  <lib-corporation-alert-settings [corporationID]="corporationID"></lib-corporation-alert-settings>
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}